import EditUser from "./EditUser/EditUser.vue";
import ChangePassword from "./ChangePassword/ChangePassword.vue";
import {UserManagement} from "@/api/modules/userManagement/UserManagement";

export default {
    name: "UserList",
    components: {
      ChangePassword,
      EditUser,
    },
    data() {
        return {
            users: [],
            roles: [],
            companies: [],
            selectedRole: '',
            selectedCompany: '',
            selectedAccount: '',
            selectedActiveStatus: 'Active',
            pageError: false,
            showChangePassword: false,
            showEditUser: false,
            activeUser: {},
            isAccountLoading: false,
            isUsersLoading: false
        }
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {

        });
        next();
    },
    beforeRouteUpdate (to, from, next){
        next();
    },
    beforeRouteLeave (to, from, next){
        next();
    },

    created(){
        this._auth = this.$store.state.auth;
        this._userManagement = new UserManagement(this._auth);

        let vm = this;
        this._userManagement.getRoles().then(roles => {
            vm.roles = roles;
        }).catch(e => {

                vm.roles = [];

                vm.$notify.error({
                    title: 'Error',
                    message: 'Error getting roles list from server.'
                });

                if (e != null) {
                    window.tracer.error(e)
                }
            }
        );


        this._userManagement.getCompanies().then(c => {
            vm.companies = c;
        }).catch(e => {

            vm.companies = [];

                vm.$notify.error({
                    title: 'Error',
                    message: 'Error getting companies list from server.'
                });

                if (e != null) {
                    window.tracer.error(e)
                }
            }
        );

    },
    mounted() {



    },
    computed: {},
    methods: {
        getAccounts(searchString, cb) {

            if (searchString == null) {
                cb([]);
                return;
            }

            if (searchString.length == 0) {
                cb([]);
                return;
            }

            this.isAccountLoading = true;
            let vm = this;
            this._userManagement.searchAccounts(searchString).then(accounts => {

                if (accounts == null) {
                    window.tracer.warn("[w831289-ADM] result returned is null (expected a valid array)");
                }

                cb(accounts);
                vm.isAccountLoading = false;
            }).catch(e => {

                    vm.isAccountLoading = false;
                    window.tracer.error("[e910906-ADM] Error getting accounts")
                    if (e != null) {
                        window.tracer.error(e);
                    }


                    cb([]);
                }
            );
        },
        onSelectedAccount(item) {
            this.selectedAccount = item;
        },
        onSearch() {

            let vm = this;
            this.isUsersLoading = true;
            window.tracer.debug(`[d550194-ADM] filters: ${this.selectedCompany}\t${this.selectedAccount}\t${this.selectedRole}`);

            this._userManagement.getUsers(this.selectedCompany, this.selectedAccount, this.selectedRole, this.selectedActiveStatus)
                .then(users => {
                    vm.users = users;
                    this.isUsersLoading = false;
                }
            ).catch(e => {
                this.isUsersLoading = false;

                window.tracer.error("[e910906-ADM] Error getting users")
                if (e != null) {
                    window.tracer.error(e);
                }
            });
        },
        resetPassword(user) {
            this.activeUser = user;
            this.showChangePassword = true;
            this.showEditUser = false;
        },
        editUser(user) {
            this.activeUser = user;
            this.showEditUser = true;
            this.showChangePassword = false;
        },
        closeDialog() {

            this.showEditUser = false;
            this.showChangePassword = false;
        },
        onEditUserCloseDialog() {
            this.activeUser = {};
            this.showEditUser = false;
        },
        onChangePasswordResult(isSuccess) {

            if (isSuccess) {
                this.$notify({
                    title: 'Success',
                    message: `Password for ${this.activeUser.firstName} ${this.activeUser.lastName} changed!`,
                    type: 'success'
                });

                this.showEditUser = false;
                this.showChangePassword = false;
            } else {
                this.$notify({
                    title: 'Error',
                    message: `An error was encountered when saving new password`,
                    type: 'error'
                });

            }
        },
        onEditUserResult(isSuccess) {
            if (isSuccess) {
                this.$notify({
                    title: 'Success',
                    message: `Updates successfully saved`,
                    type: 'success'
                });

                this.showEditUser = false;
                this.showChangePassword = false;
            } else {
                this.$notify({
                    title: 'Error',
                    message: `An error was encountered when saving changes`,
                    type: 'error'
                });

            }
        }
    }
}